import React from 'react';
import PropTypes from 'prop-types';

import {TextField as MUTextField, InputAdornment} from '@mui/material';

const TextField = (props) => {
  const [isInvalid, setIsInvalid] = React.useState(false);

  const {
    value = '',
  } = {...props};

  const {
    validation,
    onChange,
    icon: Icon,
    onBlur = () => {},
    onChangeEvent = false,
    ...textFieldProps
  } = {...props};

  const onUpdate = (e) => {
    const nextValue = e.target.value;
    if (onChangeEvent) {
      onChange(e);
    } else {
      onChange(nextValue);
    }
    if (validation && validation.regex && validation.update) {
      const re = new RegExp(validation.regex);
      const isValid = re.test(nextValue);
      validation.update(isValid);
      setIsInvalid(!isValid);
    }
  };

  const validate = () => {
    if (validation && validation.regex && validation.update) {
      const re = new RegExp(validation.regex);
      const isValid = re.test(value);
      validation.update(isValid);
      setIsInvalid(!isValid);
    }
  };

  const {InputProps: inputPropsProp, ...restProps} = textFieldProps;
  let inputProps = inputPropsProp || {};
  if (Icon) {
    inputProps = {
      ...inputProps,
      startAdornment: (
        <InputAdornment position="start">
          <Icon />
        </InputAdornment>
      ),
    };
  }

  return (
    <MUTextField
      variant={'outlined'}
      {...restProps}
      InputProps={inputProps}
      onChange={onUpdate}
      onBlur={() => validate() | onBlur()}
      error={isInvalid}
    />
  );
};

TextField.propTypes = {
  value: PropTypes.any,
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  onChange: PropTypes.func.isRequired,
  validation: PropTypes.object,
  icon: PropTypes.object,
  onChangeEvent: PropTypes.bool,
};

export default TextField;
